import fonts from '@helpers/fonts';
import { Device, from, until } from '@helpers/media';
import styled from 'styled-components';
const Container = styled.section ``;
const List = styled.ul `
  display: flex;
  flex-wrap: wrap;
  margin: -5px 0;

  @media ${until(Device.MobileLarge)} {
    justify-content: center;
  }
`;
const Item = styled.li `
  display: flex;
  flex-grow: 1;

  @media ${until(Device.MobileLarge)} {
    margin: 5px 16px;
  }

  @media ${from(Device.MobileLarge)} {
    margin: 5px 32px 5px 0;

    &:last-child {
      margin-right: 0;
    }
  }
`;
const Link = styled.a `
  display: block;
  color: currentColor;
  ${fonts.gillSans.light};
  font-size: 14px;
  line-height: 22px;
  text-decoration: none;
  text-underline-position: under;

  &:focus,
  &:hover {
    outline: none;
    text-decoration: underline;
  }
`;
export default {
    Container,
    Item,
    Link,
    List,
};
